import React, { Component } from "react";
export default class ItemCount extends Component {
  render() {
    const { count, maxOrder, minPerOrder } = this.props.data;
    const { increase, decrease, removeFromCart } = this.props.methods;
    return (
      <div className="itemCount">
        <span
          className="button increase"
          onClick={() => {
            if (maxOrder === count) {
              return null;
            } else {
              increase();
            }
          }}
        >
          <i className="icon-plus" />
        </span>
        <span className="count">{count}</span>
        {count === minPerOrder ? (
          <span className="button decrease" onClick={removeFromCart}>
            <i className="icon-delete" />
          </span>
        ) : (
          <span className="button decrease" onClick={decrease}>
            <i className="icon-minus" />
          </span>
        )}
      </div>
    );
  }
}
